import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence the well-known benign "ResizeObserver loop completed with
// undelivered notifications" browser warning so it doesn't trigger the
// react-error-overlay in preview / dev. This message is a spec-defined
// no-op — the browser will retry the next frame — and doesn't indicate
// a real bug. Only suppress this exact string.
if (typeof window !== "undefined") {
  const isRO = (msg) =>
    typeof msg === "string" && msg.includes("ResizeObserver loop");
  const onErr = (e) => {
    if (isRO(e.message) || isRO(e.reason?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
    return undefined;
  };
  // Capture phase so we run before react-error-overlay's listener.
  window.addEventListener("error", onErr, true);
  window.addEventListener("unhandledrejection", onErr, true);
  // Also patch console.error, which the CRA/react-error-overlay hook
  // intercepts to surface uncaught runtime errors.
  const origErr = console.error;
  console.error = function (...args) {
    if (args.some((a) => isRO(a?.message || a))) return;
    return origErr.apply(this, args);
  };
}


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
